import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router'
import DefaultLayout from 'components/layout/DefaultLayout'
import NotFoundPage from 'components/layout/NotFoundPage'
import { layoutConfigs } from 'shared/layoutConfigs'
import { selectAppConfig } from 'services/bootup/selectors'

const mapStateToProps = (state) => ({
  appConfig: selectAppConfig(state),
})

function GlobalOnlyRoute ({ component: Component, appConfig: { isChina }, ...rest }) {
  return (
    <Route {...rest} render={ props => {
      return !isChina
        ? <Component {...props} />
        : <DefaultLayout {...layoutConfigs(isChina)}> <NotFoundPage /> </DefaultLayout>
    }} />
  )
}

GlobalOnlyRoute.propTypes = {
  appConfig: PropTypes.object,
  component: PropTypes.object,
}

export default connect(mapStateToProps)(GlobalOnlyRoute)
